import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { User } from "../../../types/slice.types";
import {
  getUsers,
  removeUser,
  updateExisitingUser,
} from "../../../services/users.service";

interface UsersSliceState {
  search: string;
  searchWithinActiveCity: boolean;
  page: number;
  lastFetchedPage: number;
  items: User[];
  hasMore: boolean;
  apiInProgress: boolean;
}

const initialState: UsersSliceState = {
  search: "",
  searchWithinActiveCity: false,
  page: 1,
  lastFetchedPage: 1,
  items: [],
  hasMore: false,
  apiInProgress: false,
};

export const getUsersList = createAsyncThunk(
  "get/Users",
  async (
    { search, city }: { city?: string; search?: string },
    { rejectWithValue }
  ) => {
    const { data, error } = (await getUsers(search, city)) as {
      data: { users: User[]; page: number; hasMore: boolean };
      error: any;
    };

    if (error) rejectWithValue(error);

    return data;
  }
);

export const deleteUser = createAsyncThunk(
  "delete/User",
  async ({ userId }: { userId: string }, { rejectWithValue }) => {
    const { data, error } = (await removeUser(userId)) as {
      data: { userId: string };
      error: any;
    };

    if (error) rejectWithValue(error);

    return data;
  }
);

export const updateUser = createAsyncThunk(
  "update/User",
  async ({ user }: { user: User }, { rejectWithValue }) => {
    const { data, error } = (await updateExisitingUser(user)) as {
      data: { user: User; message: string };
      error: any;
    };

    if (error) rejectWithValue(error);

    return data;
  }
);

export const usersSlice = createSlice({
  name: "users",
  initialState,
  reducers: {
    setApiInProgress: (state, action) => {
      state.apiInProgress = true;
    },
  },
  extraReducers(builder) {
    builder.addCase(getUsersList.fulfilled, (state, action) => {
      const payload = action.payload;
      state.items = payload.users;
      state.page = payload.page;
      state.hasMore = payload.hasMore;
      state.apiInProgress = false;
    });

    builder.addCase(deleteUser.fulfilled, (state, action) => {
      const userID = action.payload.userId;
      state.items = state.items.filter((user) => user._id !== userID);
    });

    builder.addCase(updateUser.fulfilled, (state, action) => {
      const updatedUser = action.payload.user;
      state.items = state.items.map((user) =>
        user._id === updatedUser._id ? updatedUser : user
      );
    });
  },
});

export const { setApiInProgress } = usersSlice.actions;
export default usersSlice.reducer;
